import React, { Component } from 'react';
import SearchLayout from './SearchLayout';
import '../css/style.css';
import '../components/Home.css';
import { translate } from "react-i18next";
import {BLUE_BG, BLUE_BORDER} from '../backend/Colors';



class SearchPublicEventLayout extends Component {

 render() {
    const { t } = this.props;
   
    return <SearchLayout   title={t("publicEvents")} searchType="PUBLIC" bg={BLUE_BG} bgStrong={BLUE_BORDER} />
 }
}


export default translate("translations")(SearchPublicEventLayout);